import {
  ADMIN_BRAND_MANAGE_PROVIDERS,
  ADMIN_LOCATION_MANAGE_PROVIDERS,
  ADMIN_LOCATIONS_DETAILS,
  ADMIN_LOCATIONS_V_DRIVE,
  ADMIN_MENU,
  ADMIN_ORDER_DETAILS,
  ADMIN_WORKING_HOURS,
  SystemProblem,
} from '@vgrubs/components';
import { ProblemActionKind } from './systemProblemLabels';

/**
 * Where a problem's action goes: an admin route (opened in a new tab - the
 * problem is what support is working from) or a phone number to call.
 *
 * Null when the problem lacks what the action needs (no order id, no phone),
 * so the button is left out rather than leading nowhere.
 */
export const problemActionTarget = (
  kind: ProblemActionKind,
  problem: SystemProblem,
  phone?: string | null
): { route: string } | { tel: string } | null => {
  const { orderId, locationId, isLocation } = problem;
  // The location's own brand: its menu and providers are the location's.
  const brandId = isLocation ? null : problem.brandId;

  switch (kind) {
    case 'order':
      return orderId
        ? { route: ADMIN_ORDER_DETAILS.replace(':id', String(orderId)) }
        : null;
    case 'providers':
      if (brandId && locationId) {
        return {
          route: ADMIN_BRAND_MANAGE_PROVIDERS.replace(
            ':id',
            String(brandId)
          ).replace(':locId', String(locationId)),
        };
      }
      return locationId
        ? {
            route: ADMIN_LOCATION_MANAGE_PROVIDERS.replace(
              ':id',
              String(locationId)
            ),
          }
        : null;
    case 'menu':
      // Brand 0 is the location's own menu, as Location Details opens it.
      return locationId && (brandId || isLocation)
        ? {
            route: ADMIN_MENU.replace(
              ':locationId',
              String(locationId)
            ).replace(':brandId', String(brandId ?? 0)),
          }
        : null;
    case 'hours':
      // The same filters Brand / Location Details open the page with.
      return locationId
        ? {
            route: `${ADMIN_WORKING_HOURS}?locationIds=${locationId}${
              brandId ? `&brandIds=${brandId}` : ''
            }`,
          }
        : null;
    case 'vDrive':
      return locationId
        ? {
            route: ADMIN_LOCATIONS_V_DRIVE.replace(':id', String(locationId)),
          }
        : null;
    case 'services':
      // Location Details opens its services modal straight away with this.
      return locationId
        ? {
            route: `${ADMIN_LOCATIONS_DETAILS.replace(
              ':id',
              String(locationId)
            )}?editServices=1`,
          }
        : null;
    case 'call':
      return phone ? { tel: phone.replace(/[^\d+]/g, '') } : null;
    default:
      return null;
  }
};
